<template>
	<div>
		<side-bar icon="settings_ethernet" title="Instances online" v-model="search_text" search>
     	<template v-slot:twosubheader v-if="$is_admin()">
     		<k-tabs v-model="tab" style="margin-top: 8px; margin-bottom: 5px;">
     			<k-tab name="input" label="Input"></k-tab>
     			<k-tab name="output" label="Output"></k-tab>
     			<k-tab name="system" label="System"></k-tab>
     			<k-tab name="servers" label="Servers"></k-tab>
     		</k-tabs>
      </template>

			<k-list bordered :items="instances" key="instances" @click="open_instance_menu">

      		<template #default="{ item }">
						{{title(item)}}
      		</template>
      		<template #subtitle="{ item }">
						{{channel_title_for_instance(item)}}
      		</template>

      		<template #right="{ item }">
						<template v-if="version_found(item)">
							<span :class="version_color(item)">{{version(item)}}</span>
						</template>
						<template v-if="!version_found(item) && !is_server(item)">
							<k-icon color="danger" small>warning</k-icon>
						</template>
      		</template>

      		<template #menu="{ item }">
						<k-menu offset-x :close-on-content-click="false" v-model="instance_menu[item.id]" style="width: 100%;" :transition="false">
							<div v-if="instance_menu[item.id] && $is_admin()">
								<Instance v-model="instance_menu[item.id]" :instance="item"/>
							</div>
						</k-menu>
      		</template>
      	</k-list>
		</side-bar>

  </div>
</template>

<script>
import InstanceModel from '@/models/instance.js'
import ChannelModel from '@/models/channel.js'
import Instance from '../dashboard/Instance'
import Vue from 'vue'
import SideBar from '@/components/SideBar.vue'
import naturalSort from 'natural-sort'

export default {
	components: {
		Instance,
		SideBar
	},
	data () {
		return {
			tab: "input",
			instance_menu: {},
			search_text: "",
			latest_version: "",
			natural_sort: naturalSort()
		}
	},
	computed: {
    instances () {
			var self = this;
			var type = this.tab;
			var ret = [];
			if(type == "servers") {
				ret = _.concat(
					InstanceModel.instances_by_type("headend", true),
					InstanceModel.instances_by_type("mediamtx", true),
					InstanceModel.instances_by_type("clipper", true)
				);
			} else {
				if (type == "system") {
					ret = _.concat(
						InstanceModel.instances_by_type("input", true),
						InstanceModel.instances_by_type("output", true)
					);
				} else {
					ret = InstanceModel.instances_by_type(type, true);
				}


				ret = _.filter(ret, function(instance) {
					var ch = InstanceModel.channel(instance);
					if (typeof(ch) == "undefined") return true;
					if (type == "system") {
						return ch.meta["system_channel"] === true;
					} else {
						return ch.meta["system_channel"] !== true;
					}

				})
			}

			var search = (this.search_text || "").toLowerCase();
			if (search.length > 0) {
				ret = _.filter(ret, function(instance) {
					ret = false;
					if (self.title(instance).toLowerCase().includes(search)) ret = true;
					if (self.channel_title_for_instance(instance).toLowerCase().includes(search)) ret = true;
					return ret;
				})
			}
			return ret.sort((a,b) => {
				return self.natural_sort(self.title(a), self.title(b));
			});
    }
  },
  mounted () {
  	this.load_latest_version();
  },
  methods: {
  	open_instance_menu (item) {
  		var self = this;
	  	Vue.set(this.instance_menu, item.id, !this.instance_menu[item.id]);
	  	// Pitäs piilottaa muut
	  	_.each(this.instances, (instance) => {
	  		if (instance.id != item.id) {
	  			Vue.set(self.instance_menu, instance.id, false);
	  		}
	  	})

  	},
  	load_latest_version () {
  		var self = this;
  		var url = "kepitstreamer/3/update/latest"
  		Vue.http.get(url).then((response) => {
        self.latest_version = response.body.latest.version;
      }, (response) => {
      });
  	},

    title (instance) {
      return InstanceModel.title(instance);
    },
    version (instance) {
      return InstanceModel.streamer_version(instance);
    },
    version_color (instance) {
    	if (this.latest_version == "") return "";
     	var v = this.version(instance);
     	if (v.startsWith("v2")) {
	    	if (v != this.latest_version) return "red";
	    }
    	return "";
    },
    version_found (instance) {
    	var v = this.version(instance);
    	if (v == "" || typeof(v) == "undefined" || v == null) return false;
    	return true;
    },
  	channel_title_for_instance (instance) {
      var ch = InstanceModel.channel(instance);
      return ChannelModel.title(ch);
    },
    is_server(instance) {
    	return _.includes(["headend", "mediamtx", "clipper"], instance.type)
    }
  }
}
</script>
